import { ICountriesQuery } from '@/client/types'
import { api } from '@/client/utils'

export const getCountries = async (locale: string) => {
  const url = `/locations/countries/${locale}`
  const { data } = await api.get<ICountriesQuery>(url)
  return data?.countries
}
